import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ClassInputType } from '../types/class-input-type';

@Component({
  selector: 'app-scheduled-select',
  templateUrl: './scheduled-select.component.html'
})
export class ScheduledSelectComponent {
  @Input() form: UntypedFormGroup | undefined;
  @Input() className: ClassInputType = 'app-input';
}
